'use client';
import React, {useEffect} from 'react';
import posthog from 'posthog-js';
import {PostHogProvider} from 'posthog-js/react';

export function CSPostHogProvider({children, profile}: {
    readonly children: React.ReactNode;
    profile?: any;
}) {
    useEffect(() => {
        if (!posthog.__loaded) {
            posthog.init('phc_DTI42XrscpKwkdfAZVVlKLNm881W26B3lD3kBL1FRtC', {
                api_host: 'https://us.i.posthog.com',
                person_profiles: 'identified_only',
                capture_pageview: true,
                capture_pageleave: true,
                enable_recording_console_log: true,
                ip: true,
                disable_session_recording: true,
            });
        }
    }, []);

    useEffect(() => {
        if (profile) {
            posthog.identify(profile.email);
            posthog.people.set({
                $name: profile.user_name,
                $email: profile.email,
                credits: profile.credits
            });
        }
    }, [profile]);

    if (posthog.__loaded) {
        return children
    }

    return (
        <PostHogProvider client={posthog}>
            {children}
        </PostHogProvider>
    );
}
